export default __webpack_public_path__ + "static/media/dashboard-bg-dishes.cdaa4e64.png";